// src/components/sections/Services.jsx - Updated with Learn More links
import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServiceCard } from '../ui/Card';
import Button from '../ui/Button';
import ServiceIcon from '../ui/ServiceIcons';

// Service data with proper IDs to match our service data structure
const services = [
  {
    id: 'white-collar-crime',
    title: 'Economic Offences',
    description: 'Strategic defense in matters involving financial crimes, regulatory investigations, and corporate misconduct.',
  },
  {
    id: 'arbitration',
    title: 'Arbitration',
    description: 'Expert representation in domestic and institutional arbitrations across diverse industry sectors.',
  },
  {
    id: 'criminal-litigation',
    title: 'Criminal Litigation',
    description: 'Comprehensive legal defense and advocacy in all criminal matters across courts and investigative agencies.',
  },
  {
    id: 'family-matrimonial',
    title: 'Family & Matrimonial Law',
    description: 'Compassionate counsel in divorce, custody, maintenance, and sensitive family matters.',
  },
  {
    id: 'real-estate-property',
    title: 'Real Estate & Property Litigation',
    description: 'Resolution of complex property disputes, RERA matters, and real estate transactions.',
  },
  {
    id: 'consumer-disputes',
    title: 'Consumer Disputes',
    description: 'Protection of consumer rights and defense against unfair trade practices across forums.',
  },
];

const ServicesSection = () => {
  const [visibleServices, setVisibleServices] = useState(6);

  const showMoreServices = () => {
    setVisibleServices(services.length);
  };

  return (
    // Added ID attribute for the section to enable anchor link targeting
    <section id="services" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl font-serif">Our Legal Services</h2>
          <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive legal solutions powered by expertise and innovation
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.slice(0, visibleServices).map((service, index) => (
            <div key={service.id} className="bg-white rounded-lg shadow-md overflow-hidden border-t-4 border-secondary h-full animate-[fadeIn_0.5s_ease-out]" style={{ animationDelay: `${index * 100}ms` }}>
              <div className="bg-gradient-to-r from-secondary to-secondary-dark p-5 text-white">
                <div className="flex items-center">
                  <div className="text-accent text-2xl mr-3 flex-shrink-0">
                    <ServiceIcon serviceId={service.id} />
                  </div>
                  <h3 className="text-lg font-semibold">{service.title}</h3>
                </div>
              </div>
              <div className="p-5 flex flex-col h-full">
                <p className="text-gray-600 flex-grow">{service.description}</p>
                <Link 
                  to={`/services/${service.id}`} 
                  className="mt-4 inline-flex items-center text-secondary hover:text-secondary-dark transition-colors group"
                >
                  Learn more
                  <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {visibleServices < services.length && (
          <div className="mt-12 text-center">
            <Button
              onClick={showMoreServices}
              variant="secondary" // Changed to secondary (burgundy) to match the headers
              size="lg"
              className="inline-flex items-center"
            >
              View All Services
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        )}
        
        {visibleServices === services.length && (
          <div className="mt-12 text-center">
            <Button
              href="/services"
              variant="secondary"
              size="lg"
              className="inline-flex items-center"
            >
              Explore Services in Detail
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;